import React from 'react';
import './portifolio.css';

function Portifolio() {
  return (
    <section id="portifolio" className="portifolio-section">
      <div className="container py-5">
        <div className="row">

            <div className="text-center mb-5">
                <h1 className="titulo-portifolio">Portfólio Institucional</h1>
            </div>

          {/* Coluna 1 */}
          <div className="col-lg-4 mb-4">
            <img src="/Images/Logo-WCONTEC.P.png"/>
            <h2 className="titulo-portifolio1-h2">Vamos cuidar da sua empresa daqui,</h2>
            <h2 className="titulo-portifolio2-h2"> juntos.</h2>
            <h2 className="titulo-portifolio3-h4"> A plataforma de gestão financeira e assessoria contábil online</h2>
          </div>

          {/* Coluna 2 */}
          <div className="col-lg-4 mb-4 col-borda">
            <h2 className="titulo">Apresentação da Empresa</h2>
            <p className="p-portifolio">
              A WCONTEC é uma plataforma digital que une gestão financeira, contabilidade online e tecnologia.
              Diferencia-se dos escritórios de contabilidade tradicionais ao oferecer flexibilidade, acessibilidade
              e acesso 24hs a documentos e serviços.
            </p>
            <p className="p-portifolio">
              Centralizar operações, emitir notas fiscais diretamente pela plataforma e contar com um sistema
              de cobranças automatizado permite aos empresários ganharem tempo e eficiência.
            </p>

            <h3 className="titulo-menor">Funcionalidades</h3>
            <ul>
              <li>Dashboard com relatórios em tempo real</li>
              <li>Automatização das cobranças com geração de faturas e opções de pagamento por boleto, PIX e cartão</li>
              <li>Emissão integrada de notas fiscais eletrônicas: NF-e, NFC-e e NFS-e</li>
              <li>Controle de estoque simples e intuitivo</li>
              <li>Drive digital para documentos fiscais</li>
              <li>Fechamento contábil automatizado</li>
            </ul>
          </div>

          {/* Coluna 3 */}
          <div className="col-lg-4 mb-4 col-borda">
            <h2 className="titulo">Diferenciais</h2>
            <ul>
              <li>Atendimento humanizado e especializado</li>
              <li>100% digital, com acesso em nuvem</li>
              <li>Integração contábil-fiscal em tempo real</li>
              <li>Redução de custos com automação</li>
              <li>Alta segurança de dados</li>
            </ul>

            <div className="espaco-imagem">
                <img src="/Images/Portifolio/dashboard.png" alt="Dashboard" />
            </div>
            <div className="espaco-imagem">
                <img src="/Images/Portifolio/drive.png" alt="Dashboard" />
            </div>

            <h3 className="titulo-menor">Contato</h3>
            <div>   
                  <ul className="list-unstyled list-inline social">
                      <li className="list-inline-item zoom-img"><a href="https://t.me/Wcontec" target="_blank"><i className="fab fa-telegram fa-2x"></i></a></li>
                      <li className="list-inline-item zoom-img"><a href="https://api.whatsapp.com/send?phone=5581996584830" target="_blank"><i className="fab fa-whatsapp fa-2x"></i></a></li>
                  </ul>
              </div>
            <a href="https://www.wcontec.com.br/" className="btn btn-outline-primary btn-lg btn-chamado zoom-img">Acesse o site</a>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Portifolio;
